module.exports = __webpack_public_path__ + "img/productiondepartmet.8c0a1dd6.png";